webpackJsonp([278353287553705],{

/***/ 429:
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"postBySlug": {
				"html": "<p>Let's see some examples of common requests for the WMS operations.</p>\n<p>We are using a demo site so please be aware that something might be unavailable in the future.</p>\n<h2 id=\"getcapabilities\"><a href=\"#getcapabilities\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>GetCapabilities</h2>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-shell\"><code>curl http://master.demo.geonode.org/geoserver/wms?request=GetCapabilities</code></pre>\n      </div>\n<p><a href=\"http://master.demo.geonode.org/geoserver/wms?request=GetCapabilities\">http://master.demo.geonode.org/geoserver/wms?request=GetCapabilities</a></p>\n<h2 id=\"getmap\"><a href=\"#getmap\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>GetMap</h2>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-shell\"><code>curl -X GET http://master.demo.geonode.org/geoserver/wms\\?\\\nservice=WMS\\&\\\nversion=1\\.1\\.0\\&\\\nrequest=GetMap\\&\\\nlayers=geonode\\:ne_50m_admin_0_countries\\&\\\nstyles=\\&\\\nbbox=-180\\.0\\,-89\\.99892578125\\,180\\.0\\,83\\.5996093750001\\&\\\nwidth=768\\&\\\nheight=370\\&\\\nsrs=EPSG\\:4326\\&\\\nformat=image\\/png</code></pre>\n      </div>\n<p><a href=\"http://master.demo.geonode.org/geoserver/geonode/wms?service=WMS&#x26;version=1.1.0&#x26;request=GetMap&#x26;layers=geonode:ne_50m_admin_0_countries&#x26;styles=&#x26;bbox=-180.0,-89.99892578125,180.0,83.5996093750001&#x26;width=768&#x26;height=370&#x26;srs=EPSG:4326&#x26;format=application/openlayers\">http://master.demo.geonode.org/geoserver/geonode/wms?service=WMS&#x26;version=1.1.0&#x26;request=GetMap&#x26;layers=geonode:ne<em>50m</em>admin<em>0</em>countries&#x26;styles=&#x26;bbox=-180.0,-89.99892578125,180.0,83.5996093750001&#x26;width=768&#x26;height=370&#x26;srs=EPSG:4326&#x26;format=application/openlayers</a></p>\n<h2 id=\"getfeatureinfo\"><a href=\"#getfeatureinfo\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>GetFeatureInfo</h2>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-shell\"><code>curl -X GET http://master.demo.geonode.org/geoserver/wms\\?\\\nSERVICE=WMS\\&\\\nVERSION=1\\.1\\.1\\&\\\nREQUEST=GetFeatureInfo\\&\\\nFORMAT=image\\/png\\&\\\nTRANSPARENT=true\\&\\\nQUERY_LAYERS=geonode\\:ne_50m_admin_0_countries\\&\\\nSTYLES\\&\\\nLAYERS=geonode\\:ne_50m_admin_0_countries\\&\\\nexceptions=application\\/vnd\\.ogc\\.se_inimage\\&\\\nINFO_FORMAT=text\\/html\\&\\\nFEATURE_COUNT=50\\&\\\nX=50\\&\\\nY=50\\&\\\nSRS=EPSG\\:4326\\&\\\nWIDTH=101\\&\\\nHEIGHT=101\\&\\\nBBOX=10\\.958003997802734\\,44\\.921722412109375\\,15\\.396480560302734\\,49.\\360198974609375</code></pre>\n      </div>\n<p><a href=\"http://master.demo.geonode.org/geoserver/geonode/wms?SERVICE=WMS&#x26;VERSION=1.1.1&#x26;REQUEST=GetFeatureInfo&#x26;FORMAT=image/png&#x26;TRANSPARENT=true&#x26;QUERY_LAYERS=geonode:ne_50m_admin_0_countries&#x26;STYLES&#x26;LAYERS=geonode:ne_50m_admin_0_countries&#x26;exceptions=application/vnd.ogc.se_inimage&#x26;INFO_FORMAT=text/html&#x26;FEATURE_COUNT=50&#x26;X=50&#x26;Y=50&#x26;SRS=EPSG:4326&#x26;WIDTH=101&#x26;HEIGHT=101&#x26;BBOX=10.958003997802734,44.921722412109375,15.396480560302734,49.360198974609375\">http://master.demo.geonode.org/geoserver/geonode/wms?SERVICE=WMS&#x26;VERSION=1.1.1&#x26;REQUEST=GetFeatureInfo&#x26;FORMAT=image/png&#x26;TRANSPARENT=true&#x26;QUERY<em>LAYERS=geonode:ne</em>50m<em>admin</em>0<em>countries&#x26;STYLES&#x26;LAYERS=geonode:ne</em>50m<em>admin</em>0<em>countries&#x26;exceptions=application/vnd.ogc.se</em>inimage&#x26;INFO<em>FORMAT=text/html&#x26;FEATURE</em>COUNT=50&#x26;X=50&#x26;Y=50&#x26;SRS=EPSG:4326&#x26;WIDTH=101&#x26;HEIGHT=101&#x26;BBOX=10.958003997802734,44.921722412109375,15.396480560302734,49.360198974609375</a></p>",
				"timeToRead": 2,
				"excerpt": "Let's see some examples of common requests for the WMS operations. We are using a demo site so please be aware that something might be...",
				"frontmatter": {
					"title": "WPS Examples",
					"cover": null,
					"date": null,
					"category": null,
					"tags": null
				}
			},
			"tableOfContents": {
				"chapters": [
					{
						"title": "1. Introduction",
						"entries": null,
						"chapters": [
							{
								"title": "1.1 OGC Standards",
								"entries": [
									{
										"entry": {
											"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_ogc.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/introduction-to-ogc"
												},
												"frontmatter": {
													"title": "Introduction to OGC"
												}
											}
										}
									}
								],
								"chapters": [
									{
										"title": "1.1.1 Web Mapping Service",
										"entries": [
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wms.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/introduction-to-wms"
														},
														"frontmatter": {
															"title": "Introduction to WMS"
														}
													}
												}
											},
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wms.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/wms-examples"
														},
														"frontmatter": {
															"title": "WMS Examples"
														}
													}
												}
											}
										]
									},
									{
										"title": "1.1.2 Web Feature Service",
										"entries": [
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wfs.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/introduction-to-wfs"
														},
														"frontmatter": {
															"title": "Introduction to WFS"
														}
													}
												}
											},
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wfs.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/wfs-examples"
														},
														"frontmatter": {
															"title": "WFS Examples"
														}
													}
												}
											}
										]
									},
									{
										"title": "1.1.3 Web Coverage Service",
										"entries": [
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wcs.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/introduction-to-wcs"
														},
														"frontmatter": {
															"title": "Introduction to WCS"
														}
													}
												}
											},
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wcs.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/wcs-examples"
														},
														"frontmatter": {
															"title": "WCS Examples"
														}
													}
												}
											}
										]
									},
									{
										"title": "1.1.4 Web Processing Service",
										"entries": [
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wps.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/introduction-to-wps"
														},
														"frontmatter": {
															"title": "Introduction to WPS"
														}
													}
												}
											},
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wps.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/wps-examples"
														},
														"frontmatter": {
															"title": "WPS Examples"
														}
													}
												}
											}
										]
									}
								]
							},
							{
								"title": "1.2 CAAML",
								"entries": [
									{
										"entry": {
											"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_caaml.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/introduction-to-caaml"
												},
												"frontmatter": {
													"title": "Introduction to CAAML"
												}
											}
										}
									}
								],
								"chapters": null
							},
							{
								"title": "1.3 INSPIRE",
								"entries": [
									{
										"entry": {
											"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_inspire.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/introduction-to-inspire"
												},
												"frontmatter": {
													"title": "Introduction to INSPIRE"
												}
											}
										}
									}
								],
								"chapters": null
							}
						]
					},
					{
						"title": "2. Standards in action",
						"entries": null,
						"chapters": [
							{
								"title": "2.1 Prepare data and toolkit",
								"entries": [
									{
										"entry": {
											"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_data_tools.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/data-and-geospatial-tools"
												},
												"frontmatter": {
													"title": "Data and geospatial tools"
												}
											}
										}
									},
									{
										"entry": {
											"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/bootstrap_servers.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/start-the-environment"
												},
												"frontmatter": {
													"title": "Start the environment"
												}
											}
										}
									}
								],
								"chapters": [
									{
										"title": "2.1.1 Manage the data",
										"entries": [
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/load_data.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/load-data"
														},
														"frontmatter": {
															"title": "Load Data"
														}
													}
												}
											},
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/clean_data.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/clean-data"
														},
														"frontmatter": {
															"title": "Clean Data"
														}
													}
												}
											}
										]
									},
									{
										"title": "2.1.2 Design the CAAML schema",
										"entries": [
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/er_design.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/caaml-model-design"
														},
														"frontmatter": {
															"title": "CAAML model design"
														}
													}
												}
											},
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/populate_data.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/populate-region"
														},
														"frontmatter": {
															"title": "Populate Region"
														}
													}
												}
											}
										]
									}
								]
							},
							{
								"title": "2.2 Build CAAML with GeoAvalanche",
								"entries": [
									{
										"entry": {
											"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/caaml_hale.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/configure-the-application-schema-for-caaml"
												},
												"frontmatter": {
													"title": "Configure the application schema for CAAML"
												}
											}
										}
									},
									{
										"entry": {
											"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/load_configuration.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/push-the-configuration-to-geo-avalanche"
												},
												"frontmatter": {
													"title": "Push the configuration to GeoAvalanche"
												}
											}
										}
									},
									{
										"entry": {
											"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/query_data.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/query-our-region-features"
												},
												"frontmatter": {
													"title": "Query our Region features"
												}
											}
										}
									}
								],
								"chapters": null
							}
						]
					},
					{
						"title": "3. Main Chapter",
						"entries": [
							{
								"entry": {
									"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/lesson_six.md absPath of file",
									"childMarkdownRemark": {
										"fields": {
											"slug": "/lesson-six"
										},
										"frontmatter": {
											"title": "Lesson Six"
										}
									}
								}
							}
						],
						"chapters": null
					}
				]
			}
		},
		"pathContext": {
			"slug": "/wps-examples"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---wps-examples-9b7e560c54c01be92d50.js